import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useMsal, useAccount } from '@azure/msal-react';
import { useAppDispatch } from '../../../app/hooks';
import { initializeComplianceItem } from '../state';
import { PageContainer, PageCard } from '../../common/components/styled-ui-elements';
import { ComplianceCreateHeader, ComplianceCreateForm } from '../components/ComplianceForm';

/**
 * ComplianceItemCreate - Main page component for creating new compliance requirements
 * Provides a clean, organized interface with logical section groupings
 */
const ComplianceItemCreate: React.FC = () => {
  const dispatch = useAppDispatch();
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  useEffect(() => {
    const userName = account?.name || 'Unknown User';
    dispatch(initializeComplianceItem(userName));
  }, [dispatch, account]);

  return (
    <PageContainer>
      <Box display="flex" justifyContent="center">
        <PageCard>
          <ComplianceCreateHeader />
          <ComplianceCreateForm />
        </PageCard>
      </Box>
    </PageContainer>
  );
};

export default ComplianceItemCreate;
